import { z } from 'zod/v4';

import { UserDTORuntype } from '../user';

// MonitoringEntity matches the Rust MonitoringEntityDto
export const MonitoringEntityRuntype = z.discriminatedUnion('type', [
    z.object({ type: z.literal('OffTheShelfPart'), id: z.string() }),
    z.object({ type: z.literal('Assembly'), id: z.string() }),
    z.object({ type: z.literal('SourcingScenario'), id: z.string() }),
    z.object({ type: z.literal('QuoteRequest'), id: z.string() }),
    z.object({ type: z.literal('BomItem'), id: z.string() }),
    z.object({ type: z.literal('Manufacturer'), id: z.string() }),
]);
export type MonitoringEntity = z.infer<typeof MonitoringEntityRuntype>;

// Define each comment entity variant with its data schema
const DesignItemEntityRuntype = z.object({ type: z.literal('DesignItem'), data: z.array(z.string()) });
const CalculationEntityRuntype = z.object({ type: z.literal('Calculation'), data: z.string() });
const RfqEntityRuntype = z.object({ type: z.literal('Rfq'), data: z.string() });
const AssemblyEntityRuntype = z.object({ type: z.literal('Assembly'), data: z.string() });
const QuoteRequestEntityRuntype = z.object({ type: z.literal('QuoteRequest'), data: z.string() });
const MonitoringCommentEntityRuntype = z.object({ type: z.literal('Monitoring'), data: MonitoringEntityRuntype });
const FlexibleCalculationEntityRuntype = z.object({ type: z.literal('FlexibleCalculation'), data: z.string() });

// Compose the discriminated union from the variants
export const CommentEntityRuntype = z.discriminatedUnion('type', [
    DesignItemEntityRuntype,
    CalculationEntityRuntype,
    RfqEntityRuntype,
    AssemblyEntityRuntype,
    QuoteRequestEntityRuntype,
    MonitoringCommentEntityRuntype,
    FlexibleCalculationEntityRuntype,
]);
export type CommentEntity = z.infer<typeof CommentEntityRuntype>;

// Derive CommentType from CommentEntity for consistency
export type CommentType = CommentEntity['type'];

export type CommentCategory = z.infer<typeof CommentCategoryRuntype>;
export const CommentCategoryRuntype = z.union([z.literal('Internal'), z.literal('Public')]);

export interface CommentDTO extends z.infer<typeof CommentRuntype> {}
export const CommentRuntype = z.object({
    id: z.string(),
    content: z.string(),
    created_by: UserDTORuntype.omit({ customer: true })
        .and(z.object({ customer: z.string().nullable() }))
        .nullable(),
    resolved_at: z.string().nullable(),
    updated_at: z.string(),
    category: CommentCategoryRuntype,
    is_automated: z.boolean(),
});
